import { PrimaryTextColor, boldFont, getRelativeFontSize, mediumFont, primaryWhiteColor, primarygreenColor, regularFont, subHeading } from "../../../../utils/styles";

const PunchInoutStyles = {
  clockIn: {
    color: "#ffffff",
    background: primarygreenColor,
    width: "150px",
    "&:hover": {
      background: primarygreenColor,
    },
  },
  clockOut: {
    color: "#ffffff",
    background: "orange",
    width: "150px",
    "&:hover": {
      background: "orange",
    },
  },
  contentWrapper: {
    width: "369px",
    padding: "40px 42px",
    position: "relative",
  },
  cardTitle: {
    fontSize: getRelativeFontSize(6),
    ...boldFont,
    color: "#0C0E2E",
    textAlign: "left",
  },

  subTitle: {
    ...subHeading,
    ...regularFont,
    color: "#6D6E82",
    fontSize: getRelativeFontSize(-2),
  },

  timeCard: {
    border: "1px solid black",
    borderRadius: "20px",
    padding: "15px",
    textAlign: "center",
    margin: "40px 25px 25px 25px ",
    marginBottom: "0px",
  },

  currTime: {
    fontSize: getRelativeFontSize(30),
    ...boldFont,
    "& span": {
      fontSize: getRelativeFontSize(10),
      color: "#6D6E82",
      marginLeft: "10px",
    },
  },
  currDate: {
    color: PrimaryTextColor,
    ...mediumFont,
    fontWeight: "600",
    fontSize: getRelativeFontSize(2),
  },

  buttons: {
    display: "flex",
    justifyContent: "center",
  },
};

export default PunchInoutStyles;
